import type { operations } from '@/types/schemas/api.main';
import { POST } from '../../_http';
type controller = operations['PublicAuthenticateRequestOtpController_post'];

export type PublicAuthenticationRequestOtpBody = controller['requestBody']['content']['application/json'];
export type PublicAuthenticationRequestOtpResponse = controller['responses']['200']['content']['application/json'];

export const requestOtp = POST('/public/authenticate/request-otp')<
  PublicAuthenticationRequestOtpBody,
  PublicAuthenticationRequestOtpResponse
>;
